const { breakpoints } = require('./layout-vars.json');

const api = {};

api.breakpointMap = new Map(breakpoints);

api.isMobileWidth = () =>
    window.matchMedia(`(max-width: ${api.breakpointMap.get('medium') - 1}px)`)
        .matches;

api.isTabletWidth = () =>
    window.matchMedia(`(max-width: ${api.breakpointMap.get('large') - 1}px)`)
        .matches;
/**
 * @TODO get rid of postcss-media-minmax
 * this way we can actually modify the
 * makeBreakpoint fn + mediaMap and
 * add a new js function
 * using window.matchMedia
 * that can test whether any media query
 * breakpoint matches in js land.
 */
api.mediaMap = breakpoints.reduce(
    (acc, [key, val], i) => ({
        ...acc,
        [`--${key}-up`]: `--${key}-up (width > ${val}px)`,
        [`--${key}-down`]: `--${key}-down (width < ${val}px)`,
        [`--${key}-only`]: [
            `--${key}-only (width < ${val}px)`,
            breakpoints[i - 1] ? ` and (width > ${breakpoints[i - 1][1]})` : ''
        ].join(''),
        [`--${key}-up-height`]: `--${key}-up-height (height > ${val}px)`,
        [`--${key}-down-height`]: `--${key}-down-height (height < ${val}px)`,
        [`--${key}-only-height`]: [
            `--${key}-only-height (height < ${val}px)`,
            breakpoints[i - 1] ? ` and (height > ${breakpoints[i - 1][1]})` : ''
        ].join('')
    }),
    {}
);

module.exports = api;



// WEBPACK FOOTER //
// ./src/theme/layout-utils.js